/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { bind } from 'decko';
import { inject } from 'dependable-react';
import { css } from 'emotion';
import { action, computed, extendObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import iconTrash from '../assets/magicBuilder/iconTrash.svg';
//import photoIcon from '../assets/magicBuilder/photoIcon.svg';
import photoIcon from '../assets/magicBuilder/photoIcon_new.png';
import { BREAKPOINT_MEDIUM, BREAKPOINT_SMALL } from '../consts/breakpoints';
import { MoreMagicType } from '../enums/MoreMagicType';
import { APP_DATA_TOKEN, BOOK_SERVICE_TOKEN, I18N_TOKEN } from '../services/InjectTokens';
import { Upload } from '../state/models';
import { Element } from '../state/models/Element';
import { Book } from '../state/models/Book';
import { Button } from './Button';
import { TextArea } from './TextArea';
import { UploadModal } from './UploadModal';
import { emojiFilter } from '../utils/emojiFilter';
import camelCase from 'lodash/camelCase';

//  ! SLIDER TASK
import Slider from 'react-slick';
import arrowLeft from '../assets/addOn/left_dedication.svg';
import arrowRight from '../assets/addOn/right_dedication.svg';
import { carouselContainer } from '../styles/carouselContainer';
import { DedicationPopup } from './DedicationPopup';

const childPreviewImages = require.context('../assets/previews', true);
const frameImages = require.context('../assets/frames');

const main = css`
  display: flex;
  flex-direction: column;
  text-align: center;

  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    text-align: initial;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

const content = css`
  width: 100%;

  p {
    max-width: 250px;
    width: 100%;
    font-size: 16px;
    line-height: 1.5;
    margin: 0 auto;
    margin-bottom: 20px;

    @media (min-width: ${BREAKPOINT_SMALL}) {
      margin: 0;
      max-width: 330px;
    }
  }
`;

const contentFlex = css`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    flex-direction: row;
  }
`;

const contentFlexCol = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  margin-top: 20px;

  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    margin-bottom: 0;
  }
`;

const imageContainer = css`
  width: 100%;
  height: auto;
  margin-bottom: 10px;

  img {
    width: 100%;
    height: auto;
  }
`;

const imagePreviewDesktop = css`
  display: block;
`;

const upload = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    width: 50%;
  }
`;

const uploadText = css`
  width: 100%;
  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    width: 50%;
  }
`;

const uploadTextDedication = css`
  width: 100%;
  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    width: 50%;
  }
`;

const uploadFrameContainer = css`
  position: relative;
  height: 235px;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  > * {
    pointer-events: none;
  }
`;

const uploadFrameInner = (hasPreviewPhoto: boolean) => css`
  position: absolute;
  top: 52%;
  left: 52%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;

  user-select: none;
  cursor: pointer;

  transform: translate(-50%, -50%);

  background-color: #f1f2f2;
  z-index: 1;

  overflow: hidden;

  @media (min-width: ${BREAKPOINT_SMALL}) {
    width: 220px;
    height: 235px;
  }

  ${!hasPreviewPhoto &&
css`
      img {
        width: 52px;

        margin-bottom: 15px;
      }
    `}

  ${hasPreviewPhoto &&
css`
      img {
        width: 100%;
        height: auto;
      }
    `}

  span {
    width: 150px;

    font-size: 10px;
    line-height: 1.58;
    text-align: center;
    color: #bfbcbc;

    @media (min-width: ${BREAKPOINT_SMALL}) {
      font-size: 12px;
    }
  }
`;

const border = css`
  position: relative;
  z-index: 2;

  @media (max-width: ${BREAKPOINT_SMALL}) {
    max-width: 297px;
  }
`;

const uploadModal = css``;

const buttonContainer = css`
  width: 100%;

  display: flex;
  justify-content: center;

  margin-top: 37px;

  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    justify-content: flex-end;
  }
`;

const iconRemove = css`
  position: absolute;
  width: auto !important;
  right: 26%;
  top: 23%;
  cursor: pointer;

  z-index: 3;
`;

const uploadContainer = css`
  position: relative;
`;

const sliderOverride = css`
  flex-direction: column;
  display: flex;
  height: 100%;
  width: 100%;

  .slick-slider {
    display: flex;
    align-items: center;

    .slick-list {
      flex: 1;

      @media (min-width: ${BREAKPOINT_MEDIUM}) {
        width: calc(100% + 40px);
        margin-right: -20px;
        margin: initial;
        width: 100%;
      }
    }

    .slick-prev {
      display: none !important;
      @media (min-width: ${BREAKPOINT_MEDIUM}) {
        display: block !important;
        position: relative;
        right: unset;
        top: unset;
        z-index: 1;
      }
    }

    .slick-next {
      position: absolute;
      right: -20px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 5;
      @media (min-width: ${BREAKPOINT_MEDIUM}) {
        position: relative;
        right: unset;
        top: unset;
        z-index: 1;
      }
    }
  }

  .slick-slide > div {
    margin: 25px 20px 0 20px;
    height: 100%;
    width: 400px;
    @media (min-width: ${BREAKPOINT_MEDIUM}) {
      margin: 50px 12px 10px 2px;
    }
  }

  .slick-slide > div > div {
    display: flex;
    justify-content: flex-start;
    height: 100%;
  }

  .slick-track {
    display: flex;
  }

  .slick-track .slick-slide {
    display: flex;
    height: auto;
    flex: 1;
    align-items: center;
    justify-content: center;
  }

  .slick-slider .slick-dots {
    list-style-type: none;
    margin: 0;
    padding: 0;
    position: absolute;
    display: flex !important;
    bottom: 5px;
    align-items: center;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: ${BREAKPOINT_MEDIUM}) {
      bottom: -10px;
    }
  }

  .slick-slider .slick-dots > li {
    margin-right: 8px;
    transition: all 0.4s ease;
    background-color: transparent;
    border: 1px solid #72659f;
    width: 7px;
    height: 7px;
    border-radius: 100%;

    @media (min-width: ${BREAKPOINT_MEDIUM}) {
    }
  }

  .slick-slider .slick-dots > li.slick-active,
  .slick-slider .slick-dots > li:hover {
    background-color: #72659f;
  }

  .slick-slider .slick-dots > li > button {
    cursor: pointer;
    opacity: 0;
    color: transparent;
    background: transparent;
  }

  .slick-slider .slick-dots > li:last-of-type {
    margin-right: 0;
  }
`;

const slideItem = css`
  padding: 40px 30px;
  text-align: center;
`;

const slideItemWrapperMargin = css`
  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    margin-top: -25px;
    padding: 25px 20px 10px 20px;
  }
`;

const slideItemWrapper = css`
  padding: 15px 0;
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  font-weight: normal;
  color: #092137;
  border-radius: 10px;
  height: calc(100% - 40px);
  box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: 970px) {
    box-shadow: 1px 1px 20px 1px rgba(0, 0, 0, 0.16);
  }
`;

const slideItemHeader = css`
  font-weight: bold;
  text-align: center;
  background-color: #28b392;
  color: #ffffff;
  text-transform: uppercase;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  padding: 10px 15px;
  margin-top: -15px;
  border-top-left-radius: 10px;
  word-break: break-word;
  border-top-right-radius: 10px;

  h3 {
    margin: 0;
  }
`;

const slideItemButton = css`
  margin: 10px 0;
  text-align: center;

  button {
    background-color: #71659f;
    box-shadow: 0px 2px 0 #4e4d7d;
    border-radius: 3px;
    color: #ffffff;
    text-transform: uppercase;
    padding: 10px 20px;
    transition: all 0.4s ease;
    transform: scale(1);
    cursor: pointer;
    font-family: Nunito, Arial, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: bold;
    line-height: 19px;
  }

  button:hover {
    transform: scale(1.05);
  }
`;

const customClass = css`
  height: 200px;
  display: none;

  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    display: block;
  }
`;
const customClassMobile = css`
  height: 100px;
  display: block;
  margin-top: 15px;
  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    margin-top: 0;
    display: none;
  }
`;

const textAreaTitle = css`
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
  margin: 0;
  display: none;

  margin-top: 20px;
  color: #12293e;

  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    line-height: 31px;
    font-size: 23px;
    display: block;
  }
`;

const textAreaSubtitle = css`
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 18px !important;
  font-weight: regular !important;
  line-height: 26px !important;
  color: #707070 !important;
  display: none;
  margin-bottom: 0 !important;

  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    margin-bottom: 20px !important;
    font-size: 13px !important;
    display: block;
    line-height: 22px !important;
  }
`;

const mobileToggle = css`
  display: block !important;

  @media (min-width: ${BREAKPOINT_MEDIUM}) {
    display: none !important;
  }
`;

const surchargeSubtitleRow = css`
    width: 100%;
    margin: 10px 0 18px 0;
    text-align: center;

    @media (min-width: ${BREAKPOINT_MEDIUM}) {
      text-align: left;
    }
`;

const surchargeSubtitleLabel = css`
    font-family: Nunito, Arial, Helvetica, sans-serif;
    font-size: 18px;
    line-height: 26px;
    font-weight: 700;
    color: #707070;
`;

const surchargeSubtitlePrice = css`
    font-family: Nunito, Arial, Helvetica, sans-serif;
    font-size: 18px;
    line-height: 26px;
    font-weight: 700;
    color: #72659f;
`;

interface IProps {
  elements: Array<Element>;
  params: Record<string, string>;
  type: MoreMagicType;
  dedicationDefault?: string;
  images: {
    childImage?: Upload;
    dedicationImage?: Upload;
  };
  onSave(params: Record<string, string>, upload?: Upload): void;
  onRemovePhoto(imageToRemove: Upload): void;
  onClose(): void;
  onError(): void;
}

interface IState {
  blob: Blob | null;
  file: File | null;
  croppedImage: string;
  uploadInProgress: boolean;
  imageToRemove: Upload | null | undefined;
  originalFileName: string;
}

function Arrow(props: any) {
  const { className, onClick, arrowDirection } = props;
  const arrowImage = arrowDirection === 'left' ? arrowLeft : arrowRight;
  const style = {
    background: `url(${arrowImage})`,
    cursor: 'pointer',
    display: 'block',
    transform: arrowDirection === 'left' ? 'translateX(18px)' : 'translateX(-15px)',
    backgroundRepeat: 'no-repeat',
    height: '25px',
    width: '15px',
  };

  return <div className={className} style={style} onClick={onClick} role="region" />;
}

const ArrowWrapper = ({ children, ...props }: any) => <div {...props}>{children}</div>;

@observer
export class MagicBuilderUpload extends React.Component<IProps> {
  private i18n = inject(I18N_TOKEN);
  private bookService = inject(BOOK_SERVICE_TOKEN);
  private appState = inject(APP_DATA_TOKEN);

  @observable
  private isDedicationPopupVisible = false;

  @observable
  private selectedDedication: string | null = null;

  @observable
  private formState: Record<string, string> = {};

  @observable
  private componentState: IState = {
    blob: null,
    croppedImage: '',
    file: null,
    imageToRemove: null,
    originalFileName: '',
    uploadInProgress: false,
  };

  constructor(props: IProps) {
    super(props);

    extendObservable(this.formState, {
      ...(props.params ? { dedication: props?.params?.dedication } : { dedication: '' }),
    });

    if (props.type === 'dedication_tab') {
      const { bookId } = this.appState;

      this.bookService.getDedicationText(bookId);
    }
  }

  @computed
  private get domainLang(): 'hr' | 'en' | 'de' | 'pl' {
    const host =
      typeof window !== 'undefined' && window.location && window.location.host ? window.location.host : '';

    return host.endsWith('.de')
      ? 'de'
      : host.endsWith('.pl')
        ? 'pl'
        : host.endsWith('.com')
          ? 'en'
          : 'hr';
  }

  @computed
  private get surchargeLabel(): string | null {
    const isPhoto = this.props.type === MoreMagicType.CHILD_IMAGE;
    const isDedication =
      this.props.type === MoreMagicType.DEDICATION || (this.props.type as any) === 'dedication_tab';

    if (!isPhoto && !isDedication) return null;

    const phrasingKey = isPhoto ? 'addon_photo_surcharge_label' : 'addon_dedication_surcharge_label';
    const translated = this.i18n.t(phrasingKey);

    if (translated && !translated.endsWith(phrasingKey)) {
      return translated;
    }

    const fallbackLabels = {
      hr: 'Nadoplata:',
      en: 'Surcharge:',
      de: 'Aufpreis:',
      pl: 'Dopłata:',
    } as const;

    return fallbackLabels[this.domainLang];
  }

  @computed
  private get surchargeCurrency(): string {
    const phrasingKey = 'addon_surcharge_currency';
    const translated = this.i18n.t(phrasingKey);

    if (translated && !translated.endsWith(phrasingKey)) {
      return translated;
    }

    const fallbackCurrencies = {
      hr: '€',
      en: '€',
      de: '€',
      pl: 'zł',
    } as const;

    return fallbackCurrencies[this.domainLang];
  }

  @computed
  private get hasTextArea() {
    return this.props.elements.find(({ type }) => type === 'dedication_text');
  }

  @computed
  private get maxLength() {
    const element = this.props.elements.find(({ type }) => type === 'dedication_text');
    if (element) {
      return element.maxLength;
    }
    return undefined;
  }

  @computed
  private get maxNumberOfLines() {
    const element = this.props.elements.find(({ type }) => type === 'dedication_text');
    if (element) {
      return element.maxNumberOfLines;
    }
    return undefined;
  }

  @computed
  private get croppedPreview() {
    const { croppedImage } = this.componentState;
    const { type, images } = this.props;

    if (croppedImage) {
      return croppedImage;
    }

    if (type === MoreMagicType.DEDICATION && images.dedicationImage) {
      return images.dedicationImage.path;
    }

    if (type === MoreMagicType.CHILD_IMAGE && images.childImage) {
      return images.childImage.path;
    }

    return null;
  }

  @computed
  private get imagePreview() {
    const { currentLanguage, bookId } = this.appState;
    const { type } = this.props;
    let image;
    let failed = false;

    try {
      image = childPreviewImages(`./${type}/${currentLanguage}/${bookId}_desktop.jpg`);
    } catch (e) {
      failed = true;
    }

    if (failed) {
      image = childPreviewImages(`./${type}/${currentLanguage}/T_${bookId}_desktop.jpg`);
    }

    return image;
  }

  @computed
  private get frameImage() {
    const { bookId } = this.appState;

    if (bookId === 20 || bookId === 31 || bookId === 36 || bookId === 37) {
      return frameImages('./uploadFrame.png');
    }

    if (bookId === 38 || bookId === 39) {
      return frameImages('./uploadFrame2.png');
    }

    return frameImages('./sharedFrame.png');
  }

  @computed
  private get titleKey() {
    if (this.props.type === MoreMagicType.CHILD_IMAGE) {
      return `${this.props.type}_title_${this.appState.bookId}`;
    } else {
      return `${this.props.type}_title`;
    }
  }

  @computed
  private get photoKey() {
    if (this.props.type === MoreMagicType.CHILD_IMAGE) {
      return `${this.props.type}_upload_photo_${this.appState.bookId}`;
    } else {
      return `${this.props.type}_upload_photo`;
    }
  }

  @computed
  private get currentBook(): Book | undefined {
    const { bookId } = this.appState as any;
    try {
      return (this.appState as any).find?.(Book, bookId);
    } catch (e) {
      return undefined;
    }
  }

  @computed
  private get domainKey(): string | undefined {
    return (this.appState as any).domain || (this.appState as any).currentDomain || (this.appState as any).domainKey;
  }

  private formatAddonPrice(raw?: string, currency?: string) {
    if (!raw) return null;

    const trimmed = raw.trim();
    const cur = currency || '€';

    if (trimmed.startsWith('+')) return trimmed;
    if (trimmed.includes('€') || trimmed.includes('zł')) return `+${trimmed}`;

    return `+${trimmed} ${cur}`;
  }

  @computed
  private get addonSurchargeText(): string | null {
    const book = this.currentBook as any;
    if (!book) return null;

    const isPhoto = this.props.type === MoreMagicType.CHILD_IMAGE;
    const isDedication =
      this.props.type === MoreMagicType.DEDICATION || (this.props.type as any) === 'dedication_tab';

    if (!isPhoto && !isDedication) return null;

    const isPhotoChargeable = book.childPhotoChargeableNormalized ?? book.childPhotoChargeable ?? book.child_photo_chargeable;
    const isDedicationChargeable = book.dedicationChargeableNormalized ?? book.dedicationChargeable ?? book.dedication_chargeable;

    if (isPhoto && !isPhotoChargeable) return null;
    if (isDedication && !isDedicationChargeable) return null;

    const addonsPrice = book.addonsPriceNormalized ?? book.addonsPrice ?? book.addons_price;
    if (!addonsPrice) return null;

    const host =
      typeof window !== 'undefined' && window.location && window.location.host ? window.location.host : '';

    const addonKeys = Object.keys(addonsPrice);
    const camelHost = camelCase(host);
    let domainPrices = (addonsPrice as any)[host] || (addonsPrice as any)[camelHost];

    if (!domainPrices) {
      const tld = host.split('.').pop();
      if (tld) {
        const camelTld = tld.charAt(0).toUpperCase() + tld.slice(1);
        const matchingKey = addonKeys.find(
          (key) => key.endsWith(`.${tld}`) || key.endsWith(camelTld),
        );
        if (matchingKey) {
          domainPrices = (addonsPrice as any)[matchingKey];
        }
      }
    }

    if (!domainPrices) {
      domainPrices = (addonsPrice as any).default;
    }

    if (!domainPrices && addonKeys.length > 0) {
      domainPrices = (addonsPrice as any)[addonKeys[0]];
    }

    if (!domainPrices) return null;

    const raw = isPhoto ? domainPrices.childPhoto ?? domainPrices.child_photo : domainPrices.dedication;
    return this.formatAddonPrice(raw, this.surchargeCurrency);
  }

  public render() {
    const responsiveBreakpoints = [
      {
        breakpoint: 420,
        settings: {
          centerPadding: '20px',
          infinite: false,
          slidesToShow: 1.1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          infinite: false,
          slidesToShow: 1.3,
        },
      },
      {
        breakpoint: 750,
        settings: {
          infinite: false,
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 990,
        settings: {
          infinite: false,
          centerPadding: '20px',
          slidesToShow: 2,
        },
      },
    ];

    return (
      <div className={main}>
        <div className={content}>
          <h3>{this.i18n.t(this.titleKey)}</h3>

          {this.addonSurchargeText && this.surchargeLabel && (
            <div className={surchargeSubtitleRow}>
              <span className={surchargeSubtitleLabel}>{this.surchargeLabel}</span>{' '}
              <span className={surchargeSubtitlePrice}>{this.addonSurchargeText}</span>
            </div>
          )}

          <p>{this.i18n.t(`${this.props.type}_description`)}</p>

          <div className={contentFlex}>
            <div className={contentFlexCol}>
              <div className={imageContainer}>
                <img src={this.imagePreview.default} className={imagePreviewDesktop} alt="Baby Frame" />
              </div>
              {this.hasTextArea && (
                <>
                  <h3 className={textAreaTitle}>{this.i18n.t('dedication_textarea_title')}</h3>
                  <p className={textAreaSubtitle}>{this.i18n.t('dedication_textarea_subtitle')}</p>
                  <TextArea
                    onChange={this.onChange}
                    placeholder={this.props.dedicationDefault}
                    value={this.formState.dedication}
                    maxLength={this.maxLength}
                    maxNumberOfLines={this.maxNumberOfLines}
                    customClass={customClass}
                  />
                </>
              )}
            </div>

            {this.props.type === 'dedication_tab' ? (
              <div className={uploadTextDedication}>
                <div className={`${carouselContainer} ${sliderOverride} `}>
                  <Slider
                    arrows
                    infinite={true}
                    dots={true}
                    nextArrow={
                      <ArrowWrapper>
                        <Arrow arrowDirection={'right'} />
                      </ArrowWrapper>
                    }
                    prevArrow={
                      <ArrowWrapper>
                        <Arrow arrowDirection={'left'} />
                      </ArrowWrapper>
                    }
                    slidesToScroll={1}
                    slidesToShow={1}
                    // responsive={responsiveBreakpoints}
                    speed={500}
                  >
                    {this.appState?.dedications &&
                      this.appState?.dedications?.length > 0 &&
                      this.appState?.dedications?.map((item: any, i: number) => {
                        return (
                          <div key={i} id={item.id} className={slideItemWrapperMargin}>
                            <div className={slideItemWrapper}>
                              <div className={slideItemHeader}>
                                <h3>{item.title || this.i18n.t('dedication_choose_title')}</h3>
                              </div>

                              <div className={slideItem}>{item.description}</div>
                              <div className={slideItemButton}>
                                <button
                                  data-text={item.description}
                                  onClick={(e: React.SyntheticEvent) => {
                                    this.onDedicationSlideClick(e);
                                  }}
                                >
                                  {this.i18n.t('dedication_choose')}
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </Slider>
                </div>
              </div>
            ) : (
              <div className={upload}>
                <div className={uploadContainer}>
                  {this.croppedPreview && !this.componentState.imageToRemove && (
                    <img src={iconTrash} className={iconRemove} alt="Remove" onClick={this.removeUploadedPhoto} />
                  )}
                  <label className={uploadFrameContainer} htmlFor="file">
                    <img className={border} src={this.frameImage.default} alt="Upload Frame" />
                    {this.croppedPreview && !this.componentState.imageToRemove ? (
                      <React.Fragment>
                        <div className={uploadFrameInner(true)}>
                          <img src={this.croppedPreview} alt="Upload Frame uploaded" />
                        </div>
                      </React.Fragment>
                    ) : (
                      <div className={uploadFrameInner(false)}>
                        <img src={photoIcon} alt="Photo Icon" />
                        <span>{this.i18n.t(this.photoKey)}</span>
                      </div>
                    )}
                  </label>
                </div>
              </div>
            )}

            {this.hasTextArea && (
              <>
                <h3 className={`${textAreaTitle} ${mobileToggle}`}>{this.i18n.t('dedication_textarea_title')}</h3>
                <p className={`${textAreaSubtitle} ${mobileToggle}`}>{this.i18n.t('dedication_textarea_subtitle')}</p>
                <TextArea
                  onChange={this.onChange}
                  placeholder={this.props.dedicationDefault}
                  value={this.formState.dedication}
                  maxLength={this.maxLength}
                  maxNumberOfLines={this.maxNumberOfLines}
                  customClass={customClassMobile}
                />
              </>
            )}
          </div>
        </div>

        <div className={buttonContainer}>
          <Button
            value={this.componentState.uploadInProgress ? this.i18n.t('upload_in_progress') : this.i18n.t('next_row')}
            onClick={this.onClick}
            isDisabled={this.componentState.uploadInProgress}
          />
        </div>
        <UploadModal className={uploadModal} onClose={this.onUploadClose} />
        <DedicationPopup
          isOpen={this.isDedicationPopupVisible}
          titleTranslationKey="dedication_popup_title"
          contentTranslationKey="dedication_popup_content"
          callbackAccept={this.popupConfirmCallback}
          callbackDecline={this.popupDeclineCallback}
        />
      </div>
    );
  }

  @bind
  @action
  private removeUploadedPhoto(e: any) {
    e.stopPropagation();
    const { type, images } = this.props;

    if (this.componentState.croppedImage) {
      this.componentState.croppedImage = '';
      this.componentState.blob = null;
    }

    if (type === MoreMagicType.DEDICATION && images.dedicationImage) {
      const dedicationImage = this.appState.findAll(Upload).find((magic) => magic.type === MoreMagicType.DEDICATION);
      if (dedicationImage) {
        this.props.onRemovePhoto(dedicationImage);
      }
    }

    if (type === MoreMagicType.CHILD_IMAGE && images.childImage) {
      const childImage = this.appState.findAll(Upload).find((magic) => magic.type === MoreMagicType.CHILD_IMAGE);
      if (childImage) {
        this.props.onRemovePhoto(childImage);
      }
    }
  }

  @bind
  private onChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    this.formState.dedication = emojiFilter(e.target.value);
  }

  @bind
  private onUploadClose(croppedImage?: Blob, originalFileName?: string) {
    if (croppedImage && originalFileName) {
      const url = URL.createObjectURL(croppedImage);

      this.componentState.croppedImage = url;
      this.componentState.blob = croppedImage;
      this.componentState.originalFileName = originalFileName;
    }
  }

  @bind
  private onDedicationSlideClick(e: React.SyntheticEvent) {
    e.preventDefault();
    e.stopPropagation();

    if (this.formState.dedication === '' && !this.formState.dedication) {
      this.formState.dedication = String(e.currentTarget.getAttribute('data-text'));
    } else {
      this.isDedicationPopupVisible = true;
      this.selectedDedication = e.currentTarget.getAttribute('data-text');
    }
  }

  @bind
  private popupConfirmCallback(e: React.SyntheticEvent) {
    e.preventDefault();
    e.stopPropagation();
    this.isDedicationPopupVisible = false;
    this.formState.dedication = String(this.selectedDedication);
  }

  @bind
  private popupDeclineCallback(e: React.SyntheticEvent) {
    e.preventDefault();
    e.stopPropagation();
    this.isDedicationPopupVisible = false;
    this.selectedDedication = null;
  }

  @bind
  private async onClick() {
    try {
      if ((this.croppedPreview && !this.componentState.blob) || (!this.croppedPreview && !this.componentState.blob)) {
        this.props.onSave(this.formState);
      }

      if (this.componentState.blob) {
        this.componentState.uploadInProgress = true;
        const data = await this.bookService.uploadPhoto(this.componentState.blob, this.componentState.originalFileName);
        const model = new Upload(data);
        this.componentState.uploadInProgress = false;
        this.props.onSave(this.formState, model);
      }
    } catch (e) {
      this.props.onError();
    }
  }
}
